import {
  Flex,
} from '@smarterservices/smarter-ui';
import VideoContainer from './VideoContainer';

import { usePlayerStore, getStore } from '../../../stores/StoreContext';
import { useState, useEffect } from 'react';
import { useFirstPaneContext } from '../../Common/SplitView/SplitViewContext';

const SidebarVideo = ({ SessionTrack, width, height }) => {
  const PlayerStore = getStore('playerStore');

  const [trackStatus, setTrackStatus] = useState(false);
  const currentTime = usePlayerStore((state) => state.currentTime);
  const isLive = usePlayerStore((state) => state.isLive);

  useEffect(() => {
    setTrackStatus(PlayerStore.getTrackStatusAtTime(SessionTrack, currentTime));
  }, [currentTime, isLive]);

  if (!trackStatus) return null;

  return (
    <Flex.Item
      as="div"
      height={`${height}px`}
      margin="none none none none"
    >
      <VideoContainer
        SessionTrack={SessionTrack}
        width={width}
        height={height}
        trackStatus={trackStatus}
      />
    </Flex.Item>
  );
};

export default SidebarVideo;
